import { Scene } from "phaser";

export class Boot extends Scene {
  constructor() {
    super("Boot");
  }

  preload() {
    //  The Boot Scene is typically used to load in any assets you require for your Preloader, such as a game logo or background.
    //  The smaller the file size of the assets, the better, as the Boot Scene itself has no preloader.
    this.load.image(
      "background",
      "assets/images/2025RO_Inspo_2_Full_No_Palette 2.png",
    );
    // RO car (text-free poster) — used by the loading screen and the title screen
    this.load.image("ro_car", "assets/video/ro-bg-poster.jpg");
  }

  create() {
    this.scene.start("Preloader");
  }
}
